<template>
  <div id="dashboard">
    <div style="background: #FFFFFF">
      <div class="common_top_wrap">
        <div class="common_tit">일드림 프로그램 안내</div>
        <div class="common_search_wrap">
          <template v-if="programPageParams.page > 1">
            <div class="btn_prev" @click="updateProgramList(programPageParams.page - 1)">←</div>
          </template>
          <template v-if="programPageParams.page < programPageParams.totalPage">
            <div class="btn_next" @click="updateProgramList(programPageParams.page + 1)">→</div>
          </template>
        </div>
      </div>
      <div class="program_list_wrap">
        <div class="program_item" :key="'program_' + item.programPid" v-for="item in programList" @click="showProgram(item)">
          <div class="top">
            <img :src="'/upload/programPost/' + item.thumbnail" v-if="item.thumbnail != null" alt="프로그램 소개 썸네일 이미지"/>
            <img src="../../assets/common/default_thumbnail.png" v-else alt="프로그램 소개 기본 썸네일"/>
<!--            <div>무료</div>-->
          </div>
          <div class="tit multiline_ellipsis">{{item.subject}}</div>
          <div class="line"></div>
          <div class="bottom">
            <div class="green" v-if="item.status === 'recruit'">모집 중</div>
            <div class="black" v-if="item.status === 'done'">마감</div>
            <div class="yellow" v-if="item.status === 'ready'">대기</div>
            <div>{{item.recruitStart}} ~ {{item.recruitEnd}}</div>
          </div>
        </div>
      </div>
    </div>
    <div style="background: rgba(164, 166, 172, 0.05)">
      <div class="common_top_wrap">
        <div class="common_tit">취업 정보 안내</div>
        <div class="common_search_wrap">
          <template v-if="jobPageParams.page > 1">
            <div class="btn_prev" @click="updateJobList(jobPageParams.page - 1)">←</div>
          </template>
          <template v-if="jobPageParams.page < jobPageParams.totalPage">
            <div class="btn_next" @click="updateJobList(jobPageParams.page + 1)">→</div>
          </template>
        </div>
      </div>
      <div class="job_list_wrap">
        <div class="job_item" :key="'job_' + item.jobPid" v-for="item in jobList" @click="showJob(item)">
          <div class="top">
            <div><img src="../../assets/job/ic_job.svg" alt=""/></div>
            <div>
              <template v-if="item.employeeType === 'EMP01'">정규직</template>
              <template v-if="item.employeeType === 'EMP02'">계약직</template>
              <template v-if="item.employeeType === 'EMP03'">파견직</template>
              <template v-if="item.employeeType === 'EMP04'">시간제</template>
              <template v-if="item.employeeType === 'EMP05'">촉탁직</template>
              <template v-if="item.employeeType === 'EMP06'">기타</template>
            </div>
          </div>
          <div class="tit multiline_ellipsis">{{item.subject}}</div>
          <div class="desc">
            {{item.companyName}}
            ·
            <template v-if="item.salaryType === 'SAL01'">월급</template>
            <template v-if="item.salaryType === 'SAL02'">연봉</template>
            <template v-if="item.salaryType === 'SAL03'">시급</template>
            {{getNumberWithCommas(item.salary)}}원
          </div>
          <div class="type">
            <div>
              <template v-if="item.eduType === 'EDU01'">초등학교</template>
              <template v-if="item.eduType === 'EDU02'">중학교</template>
              <template v-if="item.eduType === 'EDU03'">고등학교</template>
              <template v-if="item.eduType === 'EDU04'">대학교(2, 3년제)</template>
              <template v-if="item.eduType === 'EDU05'">대학교(4년제)</template>
              <template v-if="item.eduType === 'EDU06'">대학원(석사)</template>
              <template v-if="item.eduType === 'EDU07'">대학원(박사)</template>
              <template v-if="item.eduType === 'EDU08'">학력무관</template>
              <template v-if="item.eduType === 'EDU09'">기타</template>
            </div>
            <div>
              <template v-if="item.careerType === 'CAR01'">경력직</template>
              <template v-if="item.careerType === 'CAR02'">신입</template>
              <template v-if="item.careerType === 'CAR03'">경력무관</template>
            </div>
          </div>
          <div class="line"><div></div></div>
          <div class="bottom">{{item.recruitStart}} ~ {{item.recruitEnd}}</div>
        </div>
      </div>
    </div>
    <div style="background: #FFFFFF">
      <div>
        <div class="common_top_wrap">
          <div class="common_tit">공지사항</div>
        </div>
        <div class="notice_list_wrap">
          <div class="no_list_data" v-if="noticeList.length <= 0">공지사항이 없습니다.</div>
          <div class="notice_item" :key="'notice_' + item.noticePid" v-for="item in noticeList" @click="showNotice(item)">
            <div><span>{{item.subject}}</span></div>
            <div><span>{{item.updDate}}</span></div>
          </div>
        </div>
      </div>
      <div>
        <div class="common_top_wrap">
          <div class="common_tit">자료실</div>
        </div>
        <div class="notice_list_wrap">
          <div class="no_list_data" v-if="boardDataList.length <= 0">자료가 없습니다.</div>
          <div class="notice_item" :key="'boardData_' + item.dataPid" v-for="item in boardDataList" @click="showBoardData(item)">
            <div><span>{{item.subject}}</span></div>
            <div><span>{{item.updDate}}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import program from '../../script/program'
import common from '../../script/common'
import job from '../../script/job'
import notice from '../../script/notice'
import boardData from '../../script/boardData'

export default {
  data () {
    return {
      dashboardSize: common.detectMobile() ? 1 : 6,
      // List
      programList: [],
      jobList: [],
      noticeList: [],
      boardDataList: [],
      // Paging
      programPageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 1,
        size: this.dashboardSize
      },
      jobPageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 1,
        size: this.dashboardSize
      }
    }
  },
  mounted () {
    this.updateProgramList(1)
    this.updateJobList(1)
    this.updateNoticeList(1)
    this.updateBoardDataList(1)
  },
  methods: {
    getNumberWithCommas (value) {
      return common.getNumberWithCommas(value)
    },
    updateProgramList (page) {
      program.getProgram({
        page: page,
        size: this.dashboardSize
      }, response => {
        console.log('프로그램 목록', response)
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          const today = new Date()
          for (let i = 0; i < list.length; i++) {
            if (list[i].recruitStart != null && list[i].recruitEnd != null) {
              const start = new Date(list[i].recruitStart + ' 00:00:00:000')
              const end = new Date(list[i].recruitEnd + ' 23:59:59:999')
              let status = null
              if (today < start) {
                status = 'ready'
              } else if (today >= start && today <= end) {
                status = 'recruit'
              } else if (today > end) {
                status = 'done'
              }
              list[i].status = status
            }
          }
          this.programList = list
          this.programPageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: page,
            size: this.dashboardSize
          }
        } else {
          common.amsAlert('retry', '프로그램 목록을 불러오지 못했습니다.')
          this.programList = []
          this.programPageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.dashboardSize
          }
        }
      })
    },
    showProgram (item) {
      program.getProgram({
        programPid: item.programPid
      }, response => {
        console.log('프로그램 상세 정보', response)
        if (response.data.resultCode === 1) {
          this.$router.push({
            name: 'ProgramView',
            params: {
              searchParams: this.searchParams,
              data: response.data.result.body
            }
          })
        } else {
          common.amsAlert('retry', '프로그램 정보를 불러오지 못했습니다.')
        }
      })
    },
    updateJobList (page) {
      job.getJob({
        page: page,
        size: this.dashboardSize
      }, response => {
        console.log('취업정보 목록', response)
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          this.jobList = data.list
          this.jobPageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: page,
            size: this.dashboardSize
          }
        } else {
          common.amsAlert('retry', '취업정보 목록을 불러오지 못했습니다.')
          this.jobList = []
          this.jobPageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.dashboardSize
          }
        }
      })
    },
    showJob (item) {
      job.getJob({
        jobPid: item.jobPid
      }, response => {
        if (response.data.resultCode === 1) {
          this.$router.push({
            name: 'JobView',
            params: {
              searchParams: this.searchParams,
              data: response.data.result.body
            }
          })
        } else {
          common.amsAlert('retry', '취업정보 목록을 불러오지 못했습니다.')
        }
      })
    },
    updateNoticeList (page) {
      notice.getNotice({
        page: page,
        size: 5
      }, response => {
        console.log('공지사항 목록', response)
        if (response.data.resultCode === 1) {
          this.noticeList = response.data.result.body.list
        } else {
          common.amsAlert('retry', '공지사항 목록을 불러오지 못했습니다.')
          this.noticeList = []
        }
      })
    },
    showNotice (item) {
      notice.getNotice({
        noticePid: item.noticePid
      }, response => {
        console.log('공지사항 상세 정보', response)
        if (response.data.resultCode === 1) {
          this.$router.push({
            name: 'NoticeView',
            params: {
              searchParams: this.searchParams,
              data: response.data.result.body
            }
          })
        } else {
          common.amsAlert('retry', '공지사항 정보를 불러오지 못했습니다.')
        }
      })
    },
    updateBoardDataList (page) {
      boardData.getBoardData({
        page: page,
        size: 5
      }, response => {
        console.log('자료실 목록', response)
        if (response.data.resultCode === 1) {
          this.boardDataList = response.data.result.body.list
        } else {
          common.amsAlert('retry', '자료실 목록을 불러오지 못했습니다.')
          this.boardDataList = []
        }
      })
    },
    showBoardData (item) {
      boardData.getBoardData({
        dataPid: item.dataPid
      }, response => {
        console.log('자료실 상세 정보', response)
        if (response.data.resultCode === 1) {
          this.$router.push({
            name: 'BoardDataView',
            params: {
              searchParams: this.searchParams,
              data: response.data.result.body
            }
          })
        } else {
          common.amsAlert('retry', '자료실 정보를 불러오지 못했습니다.')
        }
      })
    }
  }
}
</script>

<style scoped>
#dashboard > div {
  display: flex;
  flex-direction: column;
}

.mobile_wrap #dashboard > div:nth-child(1),
.mobile_wrap #dashboard > div:nth-child(2) {
  padding: 0 16px;
  background: #FFFFFF !important;
}

#dashboard > div > div {
  width: 1140px;
  margin: auto;
}

.mobile_wrap #dashboard > div > div {
  width: 100%;
}

#dashboard > div > div.common_top_wrap {
  margin: 55px auto;
}

.mobile_wrap #dashboard > div > div.common_top_wrap {
  flex-direction: row;
  width: 100%;
  margin: 55px 0 30px;
}

.mobile_wrap #dashboard .common_search_wrap {
  margin: auto 0 auto auto;
}

#dashboard .common_search_wrap > .btn_prev,
#dashboard .common_search_wrap > .btn_next {
  display: inline-flex;
  height: 56px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
}

.mobile_wrap #dashboard .common_search_wrap > .btn_prev,
.mobile_wrap #dashboard .common_search_wrap > .btn_next {
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 6px;
  box-sizing: border-box;
}

#dashboard .common_search_wrap > .btn_prev {
  background: rgba(164, 166, 172, 0.05);
  color: #0F1015;
}

#dashboard .common_search_wrap > .btn_next {
  background: #3E54EB;
  color: #FFFFFF;
}

#dashboard > div > div.program_list_wrap {
  margin-bottom: 100px;
}

.mobile_wrap #dashboard > div > div.program_list_wrap {
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);
  margin: 0;
}

#dashboard > div > div.job_list_wrap {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
}

.mobile_wrap #dashboard > div > div.job_list_wrap {
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);
}

#dashboard > div:nth-child(3) {
  display: flex;
  flex-direction: row;
  margin-bottom: 160px;
  gap: 30px;
}

.mobile_wrap #dashboard > div:nth-child(3) {
  flex-direction: column;
  padding: 16px;
}

#dashboard > div:nth-child(3) > div {
  flex-shrink: 1;
  width: calc(1140px / 2 - 15px);
  margin: auto 0;
}

.mobile_wrap #dashboard > div:nth-child(3) > div {
  width: 100%;
}

#dashboard > div:nth-child(3) > div:nth-child(1) {
  margin-left: auto;
}

#dashboard > div:nth-child(3) > div:nth-child(2) {
  margin-right: auto;
}

#dashboard .notice_list_wrap {
  border-top: 3px solid #000000;
  margin-top: 40px;
}

#dashboard .notice_list_wrap > .no_list_data {
  height: 50px;
  line-height: 50px;
}

#dashboard .notice_list_wrap > .notice_item > div:nth-child(1) {
  width: 70%;
}

#dashboard .notice_list_wrap > .notice_item > div:nth-child(2) {
  width: 30%;
}

#dashboard .notice_list_wrap > .notice_item > div > span {
  color: #36414F;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
}

#dashboard .notice_list_wrap > .notice_item > div:nth-child(1) > span {
  margin-left: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue